import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { FormEntryField } from '../type'

export const TextEditor = ({ value, onChange }: FormEntryField<string>) => {
  return (
    <CKEditor
      editor={ ClassicEditor }
      data={ value }
      onChange={ (_, editor) => onChange!(editor.getData()) }
    />
  )
}
